// import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
// import { getProjects, postProject,postEditProject } from '../../Services/ProjectService';

// // export const fetchProject = createAsyncThunk(
// //   'dataset/fetch',
// //   async (id: string, thunkAPI) => {
// //     return getProject(id);
// //   }
// // );

// export const fetchProjects = createAsyncThunk('projects/fetch', async (thunkAPI) => {
//   return getProjects();
// });

// export const fetchProjectsByUser = createAsyncThunk('projects/fetchByUser', async (thunkAPI) => {
//   return getProjects();
// });

// export const createProject = createAsyncThunk(
//   'project/post',
//   async (
//     {
//       label,
//       description,
//       tags,
//       users,
//       admins
//     }: {
//       label: string;
//       description: string;
//       tags: string[];
//       users: string[];
//       admins: string[]
//     },
//     thunkAPI
//   ) => {
//     return postProject(label, description, tags, users, admins);
//   }
// );

// // Edit project Slice
// export const editProject = createAsyncThunk(
//   'projectEdit/post',
//   async (
//     {
//       label,
//       description,
//       tags,
//       users,
//       admins
//     }: {
//       label: string;
//       description: string;
//       tags: string[];
//       users: string[];
//       admins: string[]
//     },
//     thunkAPI
//   ) => {
//     return postEditProject(label, description, tags, users, admins);
//   }
// );




// export const fetchSelectedProject = createAction('projects/fetchSelected', (payload) => ({
//   payload
// }));

// // Then, handle actions in your reducers:
// export const projectmanagement = createSlice({
//   name: 'projectmanagement',
//   initialState: {
//     projects: Array(),
//     loading: false,
//     currentProject: undefined
//   },
//   reducers: {
//     updateSelectedProject: (state,action) => {
//       state.currentProject= action.payload;
//     }
    
//     // standard reducer logic, with auto-generated action types per reducer
//   },
//   extraReducers: (builder) => {
//     // Add reducers for additional action types here, and handle loading state as needed
//     builder.addCase(fetchProjects.pending, (state, action) => {
//       // state.projects = [];
//       state.loading = true;
//     });

//     builder.addCase(fetchProjects.fulfilled, (state, action) => {
//       state.projects = action.payload;
//       state.loading = false;
//     });
//     builder.addCase(fetchSelectedProject, (state, action) => {
//       state.currentProject = action.payload;
//     });
//   }
// });

// export default projectmanagement.reducer 
// export const { updateSelectedProject}=projectmanagement.actions

import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { getProjects, postProject, postEditProject } from '../../Services/ProjectService';
import axiosInstance from 'Services/APIService';

// Async thunk for fetching groups by username
export const fetchGroupsByUser = createAsyncThunk('groups/fetchByUser', async (_, thunkAPI) => {
  try {
    // Retrieve user-details from localStorage
    const userDetails = localStorage.getItem('user-details');
    if (!userDetails) {
      throw new Error('User details not found in local storage');
    }

    const { email } = JSON.parse(userDetails);
    if (!email) {
      throw new Error('Email not found in user details');
    }

    // Call the groups-by-username API
    const response = await axiosInstance.get(
      `/groups/groups-by-username?email=${encodeURIComponent(email)}`
    );
    
    // Handle multiple response structures
    // Response could be: response.data.groups, response.data.userGroups, or just response.data (array)
    let groups = Array.isArray(response.data) 
      ? response.data 
      : (response.data.groups || response.data.userGroups || response.data.data || []);
    
    if (!Array.isArray(groups)) {
      groups = [];
    }
    
    return groups;
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
    return thunkAPI.rejectWithValue(errorMessage);
  }
});

// Existing async thunks
export const fetchProjects = createAsyncThunk('projects/fetch', async (_, thunkAPI) => {
  return getProjects();
});

export const fetchProjectsByUser = createAsyncThunk('projects/fetchByUser', async (_, thunkAPI) => {
  return getProjects();
});

export const createProject = createAsyncThunk(
  'project/post',
  async (
    {
      label,
      description,
      tags,
      users,
      admins
    }: {
      label: string;
      description: string;
      tags: string[];
      users: string[];
      admins: string[];
    },
    thunkAPI
  ) => {
    return postProject(label, description, tags, users, admins);
  }
);

export const editProject = createAsyncThunk(
  'projectEdit/post',
  async (
    {
      label,
      description,
      tags,
      users,
      admins
    }: {
      label: string;
      description: string;
      tags: string[];
      users: string[];
      admins: string[];
    },
    thunkAPI
  ) => {
    return postEditProject(label, description, tags, users, admins);
  }
);

export const fetchSelectedProject = createAction('projects/fetchSelected', (payload) => ({
  payload
}));

// Define the initial state interface
interface ProjectManagementState {
  projects: any[]; // Adjust type based on your project structure
  groups: { group_id: string; label: string }[];
  loading: boolean;
  currentProject: any | undefined; // Adjust type based on your project structure
  error: string | null;
}

// Slice definition
export const projectmanagement = createSlice({
  name: 'projectmanagement',
  initialState: {
    projects: [],
    groups: [],
    loading: false,
    currentProject: undefined,
    error: null
  } as ProjectManagementState,
  reducers: {
    updateSelectedProject: (state, action) => {
      state.currentProject = action.payload;
    }
  },
  extraReducers: (builder) => {
    // Fetch projects
    builder.addCase(fetchProjects.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProjects.fulfilled, (state, action) => {
      state.projects = action.payload;
      state.loading = false;
    });

    // Fetch selected project
    builder.addCase(fetchSelectedProject, (state, action) => {
      state.currentProject = action.payload;
    });

    // Fetch groups by user
    builder.addCase(fetchGroupsByUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchGroupsByUser.fulfilled, (state, action) => {
      state.groups = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchGroupsByUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  }
});

export default projectmanagement.reducer;
export const { updateSelectedProject } = projectmanagement.actions;